
<template>
 <div id="Vue"  > 
<div class="container">
 
 
  <div class='has-info'  >
  <div   style="align-items:center;text-align:center;float:center;font-size:18px;margin-top:5px">
    重置密码
  </div>
   <el-form ref="form" :rules="rules" :model="form"   label-width="80px" style="margin: 50px">
  <el-form-item label="手机号" prop="name" required>
    <el-input v-model="form.name" placeholder="请输入手机号 " οninput="value=value.replace(/[^\d]/g,'');if(value.length > 11)value = value.slice(0, 11)"></el-input>
  </el-form-item>
  <el-form-item label="验证码" prop="code"  >
    <el-input v-model="form.code" placeholder="请输入验证码 " style="width:50%" ></el-input>
	<el-button type="primary" :loading="is_loading" @click="sendMessage" style="width:46%;margin-left:5px" :disabled="btnChangeEnable" >{{title}} </el-button>
  </el-form-item>
  <el-form-item label="新密码" prop="pwd" required>
    <el-input v-model="form.pwd" placeholder="请输入新密码 " show-password></el-input>
  </el-form-item>
  <el-form-item label="确认密码" prop="pwd1" required>
    <el-input v-model="form.pwd1" placeholder="请再次输入密码 " show-password></el-input>
  </el-form-item> 

  <el-form-item style="margin-top:10px;   " >
    <el-button type="primary" :loading="is_loading" @click="onSubmit" style="width:90%" round >确定 </el-button>
  
  </el-form-item>
 
</el-form>
 
  </div>
  
</div>
</div>
</template>
<script language="javaScript">

export default {
 
        data () {
            return {
	    	componentName: 'info',
		    userInfo: {},
			login_state : 0,
			is_loading: false, 
			title: '获取验证码',
			btnChangeEnable: false,
			form: {
			  name: '',
			  pwd: '', 
			  code: '',
			  pwd1: '',
			},
		    InterValObj: null, //timer变量，控制时间
            count : 60,  //间隔函数，1秒执行
            curCount: 0 ,//当前剩余秒数
            code:'',
			rules: {
				name: [
				  { required: true, message: "手机号不能为空", trigger: "blur" },
				  { min: 11, message: "手机号格式不正确", trigger: "blur" },
				  { max: 11, message: "手机号格式不正确", trigger: "blur" },
				],
				pwd: [
				  { required: true, message: "长度至少六位", trigger: "blur" },
				  { min: 6, message: "长度至少六位", trigger: "blur" },
				  { max: 20, message: "长度最多20位", trigger: "blur" },
				],	
				pwd1: [
				  { required: true, message: "长度至少六位", trigger: "blur" },
				  { min: 6, message: "长度至少六位", trigger: "blur" },
				  { max: 20, message: "长度最多20位", trigger: "blur" },
				],				
				},
            } 				
        },
        methods: {

			sendMessage(){	
				if ( !this.checkPhone())
					return;
				this.count = 60;
				this.curCount = this.count;  
				var data = '{"phone":"' + this.form.name + '"}' ;
				var json = JSON.parse(data); 
				this.btnChangeEnable = true;
				this.InterValObj = window.setInterval(this.SetRemainTime, 1000); // 启动计时器timer处理函数，1秒执行一次 
			
				// 向后台发送处理数据
			    let that = this;
				$.ajax({
					type: "POST", // 用POST方式传输
					dataType: "json", // 数据格式:JSON
					url: "https://www.myferp.com/sendmessage/index.php", // 目标地址
					data: json,//手机号
					error: function(XMLHttpRequest, textStatus, errorThrown) { 
				 
						   that.$message({
							message: '请求错误',
							type: 'error'
							});
								return false;
							},
					success: function (data){ 
						 console.log(data);
						 if (data.msg == 'ok'){
						   that.code = data.code;
						   console.log(that.code);
						}
					}
				}); 
			},
		   checkPhone(){ 
				 
				if(!(/^1(3|4|5|6|7|8|9)\d{9}$/.test(this.form.name))){ 
				   this.$message({
							message: '手机号格式不正确',
							type: 'warning'
							});
					return false; 
				} 
				else
					return true;
			  

            },
			//timer处理函数
           SetRemainTime() {  
				if (this.curCount == 0) {                
				  window.clearInterval(this.InterValObj);// 停止计时器
				  
				   
				  this.btnChangeEnable = false;
				  this.title = '重新发送验证码';
					}
				else { 
				  this.curCount--;
				  this.title = this.curCount + '秒后重发' ;
				}
            },
  
			onSubmit() {
		 
		        let hash = {};
				hash['username'] = this.form.name;
				hash['password'] = this.form.pwd;
				hash['password1'] = this.form.pwd1;
				hash['code'] = this.form.code;
				
				if (hash.username === ''){
                   this.$message({
							message: '请填写手机号',
							type: 'warning'
							}); 
                   return;
                   };
				if (hash.code === ''){
                   this.$message({
							message: '请填写验证码',
							type: 'warning'
							}); 
                   return;
                   };
                if (hash.password.length < 6){
                   this.$message({
							message: '密码至少六位!',
							type: 'warning'
							});  
                   return;
                   };				   
                if (hash.password === ''){
                   this.$message({
							message: '请填写密码',
							type: 'warning'
							});  
                   return;
                   };
                if (hash.password !=  hash.password1){
                   this.$message({
							message: '密码不一致!',
							type: 'warning'
							});  
                   return;
                   };
				if (hash.code != this.code){
                   this.$message({
							message: '验证码错误',
							type: 'warning'
							}); 
                   return;
                   };
				this.is_loading = true;  
				$.post('https://www.myferp.com/admin/auth/pwdChg', hash)
                 .then((response)=>{
				    this.is_loading = false;
			        if (response.errno > 0){
					   this.$message({
							message: response.errmsg,
							type: 'error'
							});
						return;
						}
				    if (response.errno == 0){
					   this.$message({
							message: '更改成功， 将前往登录页面',
							type: 'success'
							}); 
						}
                    window.location.href= '/login';
                 },(request)=>{
				    this.is_loading = false;
				    this.$message({
							message: '请求错误!',
							type: 'error'
							}); 
                 })
				 
			},
			
			mounted() {
				 
				console.log('hi');
				let that = this;
				var info1 = localStorage.getItem("userInfo"); 
				var userName = '';
				var userId = 0;
				var userPhone = '';
				var userEmail = '';
				if (info1 != undefined && info1 != '' && info1 != "undefined"){
				  var info = JSON.parse(info1);
				  that.userInfo = info ;   
				  console.log(that.userInfo);
				  }else
				  {
				  console.log(info1);
				  }
			
			   } 
 

		}        

    } ;
  
   
</script>
 

  <style scoped>
  body {
    background: #eceaea;
    height: 100%;
}

.container {
    background: #eceaea;
    display: flex;
	flex-direction: column;
    align-items: center;
    overflow-x: hidden;
	padding-bottom: 60px;
}
.logo{
    display: flex;
    justify-content: flex-start;
	position: absolute;
	left: 20px;
	top: 20px;
}

.has-info {
    display: flex;
    flex-direction: column;
	margin-top:100px;
    padding: 50px;
	background: #fff;
	width: 500px;
	height: 500px;
	border-radius: 10px;
     
    margin-bottom: 10px;
    position: relative;
}

.has-info .info-item {
    padding: 30rpx 0;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    background: #fff;
   /* border-radius: 10px;
    box-shadow: 2px 2px 2px #f1f1f1; */
    margin-bottom: 20px;
    position: relative;
}

.has-info .info-item .edit-wrap{
    padding: 30rpx;
    position: absolute;
    right: 0;
    bottom: 0;
    display: flex;
    justify-content: center;
    align-items: center;
}

.has-info .info-item .edit-wrap .img{
    width: 42rpx;
    height: 42rpx;
}

.has-info .info-item .selected {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 30rpx 0 30rpx 30rpx;
}

.has-info .info-item .selected .img {
    width: 40rpx;
    height: 40rpx;
}

.has-info .info-item .info-wrap{
    display: flex;
    flex-direction: column;
    padding-left: 5px;
}

.has-info .info-item .info-wrap .addr {
    display: flex;
    flex-direction: column;
    margin-bottom: 10rpx;
}

.has-info .info-item .info-wrap .addr .top {
    font-size: 30rpx;
    font-weight: 500;
    margin-bottom: 5px;
}

.has-info .info-item .info-wrap .addr .text {
    font-size: 24rpx;
    color: #777;
}

.has-info .info-item .info-wrap .addr .img-wrap {
    width: 44rpx;
    height: 44rpx;
    margin-right: 10rpx;
}

.has-info .info-item .info-wrap .name {
    display: flex;
    justify-content: flex-start;
    align-items: center;
}

.has-info .info-item .info-wrap .name .img-wrap {
    width: 44rpx;
    height: 44rpx;
    margin-right: 10rpx;
}

.has-info .info-item .info-wrap .name .img {
    width: 42rpx;
    height: 42rpx;
}

.has-info .info-item .info-wrap .name .default {
    font-size: 22rpx;
    color: #ff3456;
    background: #faedef;
    text-align: center;
    padding: 2rpx 10rpx;
    border-radius: 4rpx;
}

.has-info .info-item .info-wrap .name .text {
    font-size: 26rpx;
    margin-right: 10rpx;
}

.has-info .info-item .id-wrap {
    display: flex;
    flex-direction: column;
}

.has-info .info-item .id-wrap .ids {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    font-size: 26rpx;
    color: #5d6777;
    margin-bottom: 8rpx;
}

.has-info .info-item .id-wrap .ids .id-name {
    margin-right: 20rpx;
}

.has-info .info-item .id-wrap .no-ids {
    font-size: 26rpx;
    color: #ffbb12;
}

.has-info .add-btn {
    display: flex;
    justify-content: center;
    align-items: center;
    background: #fff;
    border-radius: 10rpx;
    box-shadow: 2rpx 8rpx 18rpx #f1f1f1;
    margin-bottom: 24rpx;
    padding: 30rpx 0;
}

.has-info .add-btn .icon-wrap {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 40rpx;
    height: 40rpx;
    margin-right: 8rpx;
}

.has-info .add-btn .icon-wrap .img {
    width: 40rpx;
    height: 40rpx;
}

.has-info .add-btn .text {
    font-size: 28rpx;
    color: #ffc310;
}

.no-info {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin-top: 300rpx;
}

.no-info .img {
    width: 100rpx;
    height: 100rpx;
    margin-bottom: 30rpx;
}

.no-info .text {
    font-size: 30rpx;
    color: #999;
    text-align: center;
    margin-bottom: 30rpx;
}

.no-info .add-btn {
    color: #192841;
    /* background: #ff3456; */
    background: linear-gradient(to right, #f8dd66, #fae277);
    border-radius: 100px;
    width: 400rpx;
    height: 80rpx;
    line-height: 80rpx;
    text-align: center;
    font-size: 28rpx;
    margin: 0 auto;
}

.btn-submit { 
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
}
.btn-submit .btn {
    width: 100%;
    background: linear-gradient(to right,  #6d97f8, #5cb3f3);
    color: #fff;
    font-size: 20px;
    text-align: center;
    height: 110rpx;
    line-height: 100rpx;
}
.btn-wrap {
    position: fixed; 
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
}

.btn-wrap .btn {
    width: 100%;
    background: linear-gradient(to right, #6d97f8, #5cb3f3);
    color: #fff;
    font-size: 28rpx;
    text-align: center;
    height: 110rpx;
    line-height: 100rpx;
}
.error{
    color: red;
	font-size: 16px;
}
</style>  


// WEBPACK FOOTER //
// src/components/pwdChg.vue